import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'

const StyledDiv = styled.div`
  font-weight: bold;
  color: ${colours.white};
  padding: 12px;
  margin: 12px;
  padding-left: 16px;
  padding-right: 10px;
  background: ${colours.darkBlue};
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
  left: 38px !important;
`


interface IProps {
  onClick: () => void
}

const ImageControl = (props: PropsWithChildren<IProps>) => (
  <StyledDiv onClick={props.onClick}>{props.children}</StyledDiv>
)

export default ImageControl
